import { defineStore } from 'pinia'
import { getMe } from '@/modules/auth/api/user.service'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        isLoaded: false,
        companyLogoVersion: 0
    }),

    getters: {
        isAuthenticated: (state) => !!state.user
    },

    actions: {
        companyLogoChanged(hasLogo) {
            if (this.user) this.user.hasCompanyLogo = hasLogo
            this.companyLogoVersion++
        },

        setUser(user) {
            this.user = user
            this.isLoaded = true
        },

        clearUser() {
            this.user = null
            this.isLoaded = true
        },

        async fetchMe() {
            try {
                const res = await getMe()
                this.user = res.data
            } catch (e) {
                this.user = null
            } finally {
                this.isLoaded = true
            }
        }
    }
})
